const navPath = ["/home", "/classify", "/service", "/mine"]

export default navPath;